import { ui } from '@/constants';
import { MBV2CachedHoverEntree } from '@/models';
import { NutritionLinkClickEvent } from '@/services/analytics/events';
import { NutritionLinkClickType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgNutritionCalculatorPrimaryBanner',
})
export default class CmgNutritionCalculatorPrimaryBanner extends Vue {
  @Prop({ default: null, type: Object })
  hoveredEntree!: MBV2CachedHoverEntree | null;

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.tablet;
  }

  get heroBannerUrl() {
    return this.$appStore.state.cms.images.nutritionCalculator.heroBanner.default;
  }

  onClickAllergens() {
    this.$services.analytics.send(new NutritionLinkClickEvent(NutritionLinkClickType.MealSelectAllergenStatement));
  }
}
